import React from 'react'


export default function Footer() {
  return (
    <div className="footer">

    <p>Powered by <a href="https://cosmicjs.com">CosmicJs</a> Inspired by <a href="https://medium.com/">Medium</a> <a href="https://github.com/MdRashid62" title="Visit on GitHub"> | Muhammad Rashid</a> </p>

    </div>
  )
}
